import { z } from 'zod/v4';
import { TerritorialLevel } from '../types/countries.types';

export const TERRITORIAL_LEVELS = Object.values(TerritorialLevel);

const territorialLevelSchema = z.enum(TERRITORIAL_LEVELS);

const parentIdSchema = z
  .string()
  .regex(/^\d+$/, 'El ID debe contener solo dígitos')
  .or(z.literal(''));

export const countrySchema = z.object({
  officialName: z.string().min(1, 'El nombre oficial es requerido').trim(),
  commonName: z.string().min(1, 'El nombre común es requerido').trim(),
  currencyCode: z.string().min(1, 'La moneda base es requerida'),
});

export const createCountrySchema = countrySchema
  .extend({
    isoCode: z.string().optional(),
    level: territorialLevelSchema,
    parentId: parentIdSchema,
  })
  .superRefine((data, ctx) => {
    if (data.level === TerritorialLevel.Pais) {
      if (!data.isoCode || data.isoCode === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'El código ISO es requerido',
          path: ['isoCode'],
        });
      } else if (data.isoCode.length !== 2 || !/^[A-Z]{2}$/.test(data.isoCode)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'El código ISO debe tener 2 letras mayúsculas',
          path: ['isoCode'],
        });
      }
      if (data.parentId && data.parentId !== '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Un país no puede tener padre',
          path: ['parentId'],
        });
      }
    } else {
      if (!data.parentId || data.parentId === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'El parentId es requerido para este nivel',
          path: ['parentId'],
        });
      }
    }
  });

export const updateCountryWithTerritorySchema = countrySchema
  .extend({
    level: territorialLevelSchema,
    parentId: parentIdSchema,
  })
  .superRefine((data, ctx) => {
    if (data.level !== TerritorialLevel.Pais) {
      if (!data.parentId || data.parentId === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'El parentId es requerido para este nivel',
          path: ['parentId'],
        });
      }
    } else {
      if (data.parentId && data.parentId !== '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Un país no puede tener padre',
          path: ['parentId'],
        });
      }
    }
  });

export const updateCountrySchema = countrySchema;

export type CreateCountryFormValues = z.infer<typeof createCountrySchema>;
export type UpdateCountryFormValues = z.infer<typeof updateCountrySchema>;
export type UpdateCountryWithTerritoryFormValues = z.infer<typeof updateCountryWithTerritorySchema>;
